export const de = {
    translation: {
        meta: {
            'de-DE': 'English Version',
            logout: 'Abmelden',
            refresh: 'Refresh Token',
        },
        lead: {
            list: {
                tableHead: {
                    leadId: 'Lead ID',
                    leadSource: 'Lead-Quelle',
                    contractId: 'Vertragsnummer',
                    customerType: 'Vertragsart',
                    companyName: 'Firma',
                    armadaCustomerId: 'Armada Kundennummer',
                    leasmanCustomerId: 'Leasman Kundennummer',
                    customerFullName: 'Name / Ansprechpartner',
                    leadCreationTimestamp: 'Erstellt am',
                    status: 'Bearbeitungsstatus',
                    customerEmail: 'Kunden E-Mail-Adresse',
                    publicationTitle: 'Kategorie',
                },
                messages: {
                    nothing: 'Keine passenden Daten gefunden.',
                },
                tools: {
                    refresh: 'Aktualisieren',
                    excelExport: 'Nach Excel exportieren',
                    filterSpam: 'Mehrfachanfragen ausblenden',
                    all: 'alle',
                },
                tabs: {
                    workflowTodos: 'Leads zur manuellen Bearbeitung',
                    workflowOpen: 'offene Leads',
                    allLeads: 'alle Leads',
                },
                multipleRequests: 'Mehrfachanfrage innerhalb kurzer Zeit',
            },
            detail: {
                tools: {
                    refresh: 'Daten aktualisieren',
                    back: 'Zur Übersicht',
                    task: 'Manueller Workflow',
                    tasks: {
                        ARMADA_CUSTOMER_CREATION: 'Armada Kunden-Id übertragen',
                        LEASMAN_CUSTOMER_CREATION: 'Leasman Kunden-Id übertragen',
                        MASTER_CONTRACT_ASSIGNMENT: 'Mantelvertrags-Id übertragen',
                        CREDIT_CHECK: 'Kreditcheck',
                        CANCEL: 'Lead schließen',
                        CONTRACT_ACTIVATION: 'Vertrag freischalten',
                        CLOSE_LEASMAN_CONTRACT: 'Leasman Vertrag schließen',
                    },
                },

                box: {
                    general: {
                        headline: 'Allgemein',
                        leadSource: 'Lead-Quelle',
                        leadId: 'Lead Id',
                        leadState: 'Status',
                        type: 'Vertragsart',
                        armadaCustomerId: 'Armada Kunden-Id',
                        leasmanCustomerId: 'Leasman Kunden-Id',
                        creationTimestamp: 'Erstellt am',
                    },
                    marketingData: {
                        headline: 'Marketingkampagne',
                        partner: 'Partner',
                        details: 'Klickwerte',
                    },
                    documents: {
                        emptyMessage: 'Keine Dokumente vorhanden',
                        headline: 'Dokumente aus Antragsstrecke',
                        manDocHeadline: 'Manuell erfasste Dokumente',
                        DOCUMENT_TYPE_LETTER_OF_ATTORNEY: 'Vertretungsvollmacht',
                        DOCUMENT_TYPE_LETTER_OF_ATTORNEY_SIGNER_ID: 'Ausweis des Vollmachtgebers',
                        DOCUMENT_TYPE_TRADE_REGISTRY_RECORD: 'Handelsregisterauszug',
                        DOCUMENT_TYPE_FOUNDATION_REGISTRY_RECORD: 'Stiftungregister',
                        DOCUMENT_TYPE_COOPERATIVE_REGISTRY_RECORD: 'Genossenschaftsregister',
                        DOCUMENT_TYPE_BUSINESS_REGISTRY_RECORD: 'Gewerbeanmeldung',
                        DOCUMENT_TYPE_PARTNERSHIP_AGREEMENT: 'Gewerbeanmeldung',
                        DOCUMENT_TYPE_ASSOCIATION_REGISTRY_RECORD: 'Vereinsregistereintrag',
                        DOCUMENT_TYPE_PROOF_OF_COMMERCIAL_ACTIVITY: 'Nachweis gewerblicher Tätigkeit',
                        DOCUMENT_TYPE_TRANSPARENCY_REGISTRY_RECORD: 'Transparenzregisterauszug',
                        DOCUMENT_TYPE_PROOF_OF_RESIDENCE: 'Aktuelle Meldebescheinigung',
                        DOCUMENT_TYPE_KYC_SHEET: 'KYC-Formular',
                    },
                    customer: {
                        headline: {
                            PRIVATE: 'Kundendaten',
                            BUSINESS: 'Ansprechpartner',
                        },
                        knownCustomer: 'bereits Kunde?',
                        knownCustomerValue: {
                            true: 'ja',
                            false: 'nein',
                        },
                        title: 'Titel',
                        firstName: 'Vorname',
                        lastName: 'Nachname',
                        birthdate: 'Geburtsdatum',
                        email: 'E-Mail',
                        mobilePhoneNumber: 'Mobilnummer',
                        city: 'Stadt',
                        country: 'Land',
                        houseNumber: 'Hausnummer',
                        postalCode: 'Postleitzahl',
                        streetName: 'Straße',
                        addressAddition: 'Adresszusatz',
                        person: 'Person',
                        address: 'Adresse',
                        employedSince: 'beschäftigt seit',
                        instantLeaseCustomer: 'Instant-Lease Kundenansicht',
                        '--': '',
                    },
                    leadCreator: {
                        headline: 'Antragsteller',
                        firstName: 'Vorname',
                        lastName: 'Nachname',
                        email: 'E-Mail',
                    },
                    signer: {
                        firstName: 'Vorname',
                        lastName: 'Nachname',
                        birthdate: 'Geburtsdatum',
                        email: 'E-Mail',
                        mobilePhoneNumber: 'Mobilnummer',
                        city: 'Ort',
                        country: 'Land',
                        houseNumber: 'Hausnummer',
                        postalCode: 'Postleitzahl',
                        streetName: 'Straße',
                        addressAddition: 'Adresszusatz',
                        address: 'Adresse',
                        consentGivenAt: 'WebID AGB zugestimmt am:',
                    },
                    bankAccount: {
                        headline: 'Bankdaten',
                        bankAccountOwner: 'Kontoinhaber',
                        bankName: 'Kreditinstitut',
                        iban: 'IBAN',
                        bic: 'BIC',
                    },
                    contract: {
                        headline: 'Vertragsdetails',
                        publicationId: 'Publikation',
                        mileage: 'Inklusivkilometer',
                        duration: 'Laufzeit (Monate)',
                        rateNet: 'netto',
                        rateGross: 'brutto',
                        rate: 'Rate',
                        category: 'Kategorie',
                        campaignTitle: 'Kampagne',
                        totalPrice: 'Gesamtsumme',
                        leasmanMasterId: 'Leasman Mantel',
                        leasmanContractId: 'Leasman Vertrag',
                    },
                    company: {
                        headline: 'Unternehmensdaten',
                        name: 'Unternehmensname',
                        legalForm: 'Rechtsform',
                        localCourt: 'Handelsregisterort',
                        vatId: 'Steuernummer',
                        commercialRegisterNumber: 'Handelsregister',
                        foundingDate: 'Gründungsdatum',
                        streetName: 'Straße',
                        houseNumber: 'Hausnummer',
                        addressAddition: 'Adresszusatz',
                        city: 'Stadt',
                        country: 'Land',
                        postalCode: 'Postleitzahl',
                        address: 'Adresse',
                        beneficialOwners: {
                            headline: 'Wirtschaftlich berechtigte Personen',
                            person: {
                                firstName: 'Vorname',
                                lastName: 'Nachname',
                                postalWithLocality: 'Ort',
                                role: 'Funktion',
                            },
                        },
                        authorizedRepresentatives: {
                            headline: 'Vertretungsberechtigte Personen',
                            person: {
                                firstName: 'Vorname',
                                lastName: 'Nachname',
                                role: 'Funktion',
                            },
                        },
                        phoneNumber: 'Telefonnummer',
                        emailDefault: 'E-Mail',
                        emailInvoice: 'E-Mail (Rechnungsversand)',
                        emailSepa: 'E-Mail (SEPA-Lastschrift)',
                        '--': '',
                    },

                    delivery: {
                        headline: 'Logistik',
                        product: 'Produkt',
                        priceNet: 'netto',
                        priceGross: 'brutto',
                        priceFree: 'kostenlos',
                        price: 'Einmalkosten',
                        _: '',
                        types: {
                            HOME_DELIVERY: 'Lieferung',
                            PICK_UP: 'Abholung',
                        },
                        deliveryDate: 'Wunschtermin',
                        deliveryTime: '',
                        deliveryTimes: {
                            MORNING: 'Vormittags',
                            AFTERNOON: 'Nachmittags',
                        },
                        soonAsPossible: 'so bald wie möglich',
                    },
                    KYC: {
                        missing: {
                            headline: 'Ergebnis Identifikation',
                            description: 'Die Identifikation wurde noch nicht gestartet.',
                        },
                        signer: {
                            headline: 'Unterzeichner',
                            name: 'Name',
                            state: 'Status',
                            emptyMessage: 'Keine Unterzeichner vorhanden',
                            details: 'Unterzeichner-Details',
                            consent: 'WebID AGB',
                            authorized: 'bevollmächtigt',
                            representative: 'vertretungsberechtigt',
                        },
                        idNow: {
                            headline: 'Ergebnis Identifikation (IDnow)',
                            status: 'Status',
                            date: 'Datum der Identifikation',
                        },
                        webId: {
                            headline: 'Ergebnis Identifikation (WebId)',
                            status: 'Status',
                            date: 'Zeitpunkt',
                        },
                    },
                    identificationLog: {
                        headline: 'Identifikationsereignisse',
                        result: 'Ergebnis',
                        reason: 'Grund',
                        timestamp: 'Datum',
                        emptyMessage: 'Keine Ergebnisse bisher',
                    },
                    idNow: {
                        headline: 'Aktueller Status bei IDnow',
                        infoHeadline: 'Identifikation ausstehend',
                        infoText: 'Der Kunde wurde noch nicht an IDnow übermittelt!',
                    },
                    mailjetEvents: {
                        headline: 'MailJet Events',
                        button: 'Zeige MailJet Events',
                        errorHeadline: 'Irgendetwas ist schief gelaufen!',
                        errorHint: 'Bitte probiere es später noch einmal.',
                        noDataHint: 'Noch keine MailJet-Events verfügbar.',
                        table: {
                            mailType: 'Mailtyp',
                            date: 'Datum',
                            event: 'Event',
                            payload: 'Payload',
                        },
                    },
                },

                errors: {
                    headline: 'Es sind Fehler aufgetreten',
                    retry: 'Nächster Versuch',
                    message: 'Meldung',
                },
            },
            errors: {
                auth: 'Sie haben keine Berechtigung um auf die folgenden Daten zuzugreifen: ',
                generic: 'Die folgenden Daten konnten nicht abgerufen werden: ',
                metadata: 'Metadaten',
                leadData: 'Leadinformationen',
            },
            fields: {
                post: 'Daten senden',
                armadaCustomerId: 'Armada Kunden-Id eingeben',
                leasmanCustomerId: 'Leasman Kunden-Id eingeben',
                leasmanMasterContractId: 'Mantelvertrags-Id eingeben',
                leasmanMasterContractId_manual: 'manuell eintragen',
                pleaseSelect: 'bitte wählen',
                errorEmpty: 'Bitte Feld ausfüllen / auswählen',
                errorNumbersOnly: 'Nur Zahlen mit tausender Trennzeichen erlaubt (z.B. 123.456)',
                question1: 'Soll der Lead / Vorgang wirklich geschlossen werden?',
                cancel: 'Vorgang schließen',
                abort: 'Abbrechen',
                contractActivation: 'Bitte bestätigen durch Klick auf "Daten senden"',
                creditCheck: 'Hier wird das Ergebnis aus dem Credit Check für den Workflow benötigt',
                creditCheck_SUCCESS: 'Erfolgreich',
                creditCheck_REJECT: 'Nicht Erfolgreich',
            },
        },
        publicationEditor: {
            headline: 'Publikations-Editor',
            back: 'Zurück',
            next: 'Weiter',
            abort: 'Abbrechen',
            save: 'Speichern',
            confirmDialog: {
                headline: 'Änderungen übernehmen?',
                hint: 'Stelle sicher, dass du eine Kopie der Publikation erstellt hast',
                success: 'Änderungen erfolgreich übernommen!',
                error: 'Es ist ein Fehler aufgetreten!',
            },
            steps: {
                selectPublication: {
                    label: 'Publikation auswählen',
                },
                editPublication: {
                    label: 'Publikation editieren',
                    validationError: 'Ungültiges JSON',
                },
                verifyPublication: {
                    label: 'Publikation verifizieren',
                    old: 'Alt',
                    new: 'neu',
                },
            },
        },
        carlos: {
            errors: {
                api: 'Fehler beim Laden der Daten aus Carlos',
            },
        },
    },
};
